import styled from 'styled-components';
import { ModalBackdrop, modalPanelDialog } from '../ModalPrimitives.styled';

export { ModalBackdrop };

export const FormContainer = styled.div`
  ${modalPanelDialog}
  position: absolute;
  top: 50%;
  left: 50%;
  width: 288px;
  padding: 24px;
  transform: translate(-50%, -50%);

  opacity: 0;
  animation: modalFadeIn 350ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
`;

export const FormText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 40px;
  letter-spacing: 0.04em;
`;

export const Label = styled.p`
  font-size: 10px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 4px;
`;

export const Input = styled.input`
  color: ${p => p.theme.colors.text.text};
  border: none;
  font-size: 12px;
  line-height: 1.5;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 30px;
  border: 1px solid transparent;
  width: 100%;
  padding: 11px 16px;
  box-sizing: border-box;
  ::placeholder {
    color: ${p => p.theme.colors.text.gray};
  }
  :focus {
    outline: ${p => p.theme.colors.main.orangeMain};
    border: 1px solid ${p => p.theme.colors.main.orangeMain};
  }
`;

export const BtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
`;

export const CloseBtn = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: 250ms;

  :hover {
    transform: scale(1.2);
  }
`;

export const WrapPassw = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const IconWrap = styled.div`
  position: absolute;
  bottom: 8px;
  right: 12px;
`;

export const ErrorMes = styled.span`
  display: flex;
  font-size: 14px;
  justify-content: center;
  margin-bottom: 10px;
  color: ${p => p.theme.colors.diagram.expenses};
`;

export const Message = styled.p`
  font-size: 10px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.04em;
  margin-bottom: 16px;
  color: ${p => p.theme.colors.text.text};
`;

export const SmallIconWrap = styled.div`
  position: absolute;
  top: 116px;
  right: 36px;
`;
